import { z } from 'zod';
import { DEAL_LOST_REASON_VALUES, DEAL_SOURCE_VALUES } from '../constants/dealSources.js';
export const dealCreateSchema = z.object({
    project_id: z.string().uuid(),
    pipeline_id: z.string().uuid(),
    stage_id: z.string().uuid(),
    name: z.string().min(1).max(500),
    account_id: z.string().uuid().optional().nullable(),
    primary_lead_id: z.string().uuid().optional().nullable(),
    amount: z.coerce.number().min(0).max(999_999_999).optional(),
    currency: z.string().length(3).optional(),
    expected_close_date: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .optional()
        .nullable(),
    owner_user_id: z.string().uuid().optional().nullable(),
    source: z.enum(DEAL_SOURCE_VALUES).optional(),
    notes: z.string().max(10000).optional().nullable(),
    lost_reason: z.enum(DEAL_LOST_REASON_VALUES).optional().nullable(),
    competitor: z.string().max(200).optional().nullable(),
});
export const dealUpdateSchema = dealCreateSchema
    .partial()
    .omit({ project_id: true, pipeline_id: true })
    .extend({
    stage_id: z.string().uuid().optional(),
});
export const dealListQuerySchema = z.object({
    project_id: z.string().uuid(),
    pipeline_id: z.string().uuid().optional(),
    stage_id: z.string().uuid().optional(),
});
//# sourceMappingURL=deal.js.map